/* ============================================================
   EMBER SUPPLY — Scroll Reveal Animations
   ------------------------------------------------------------
   Dos sistemas conviven (100% aditivo, nada se pierde):

   A) data-reveal (existente, desplegado): elementos marcados
      en el Liquid (hero, cards con stagger, columnas de
      producto, catálogo). Gateado por html.ss-anim — si este
      JS no carga, el CSS nunca oculta nada.

   B) ember-reveal (layer nuevo): auto-taguea headings, tarjetas
      y .rte NO cubiertos por (A) — páginas Horizon (contacto,
      políticas, búsqueda) y contenido futuro. Excluye elementos
      dentro de [data-reveal] para no duplicar animación.
      API pública: window.EmberReveal.rescan()
   ============================================================ */

/* ---------- A) Sistema data-reveal (existente) ---------- */
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry.isIntersecting) continue;
      var el = entry.target;
      var d = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
      if (d) {
        el.style.transitionDelay = d + 'ms';
        // quita el delay tras la animación para no ralentizar hovers posteriores
        (function (node, delay) {
          setTimeout(function () { node.style.transitionDelay = ''; }, delay + 700);
        })(el, d);
      }
      el.classList.add('is-in');
      io.unobserve(el);
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });

  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* ---------- B) Sistema ember-reveal (layer aditivo) ---------- */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function autoTagRevealElements() {
    // Selectores ajustados a las clases reales del tema (Paso 1):
    // .p-card / .ss-review-card en lugar de .product-card/.card/.grid__item
    var selectors = [
      "h1", "h2", "h3",
      ".p-card", ".ss-review-card",
      ".rte", ".hero__content", ".featured-collection__item"
    ];
    var seen = new Set();
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (seen.has(el)) return;
        // No duplicar animación en elementos ya cubiertos por data-reveal
        if (el.closest('[data-reveal]')) return;
        seen.add(el);
        el.classList.add("ember-reveal");
      });
    });
  }

  function initObserver() {
    if (prefersReducedMotion) {
      document.querySelectorAll(".ember-reveal").forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: "0px 0px -8% 0px", threshold: 0.1 });

    document.querySelectorAll(".ember-reveal").forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    autoTagRevealElements();
    initObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.EmberReveal = {
    rescan: function () { autoTagRevealElements(); initObserver(); }
  };
})();
